import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-202abd42"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import popupImg from '@/assets/popup.png'
import { useAuthStore } from '@/stores/auth'
import { onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PromoPopup',
  setup(__props) {

const authStore = useAuthStore()
const hidePopup = () => {
  authStore.setHidePromoPopup()
}
onMounted(() => {
  const closeTime = setTimeout(() => {
    authStore.setHidePromoPopup()
    clearTimeout(closeTime)
  }, 10000)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "popup",
    onClick: hidePopup
  }, [
    _createElementVNode("img", {
      class: "image",
      src: _unref(popupImg),
      alt: "Promo"
    }, null, 8, _hoisted_1)
  ]))
}
}

})